import { fromJS } from 'immutable';
import * as actions from '../utils/Constants'
import moment from 'moment';

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.UPDATE_TRAINING + actions.FULFILLED:
        case actions.GET_TRAINING + actions.FULFILLED:
            return state.set('training', fromJS(action.payload));
        case actions.SET_TRAINING_FIELD: {
            let newState = state.setIn(['training', action.field], action.payload);
            if (action.field === 'projectId') {
                newState = newState.delete('project');
            }
            if (action.field === 'trainingTypeId') {
                newState = newState.delete('trainingType');
            }
            return newState
        }
        case actions.SET_TRAINING_LOCATION: {
            return state.setIn(['training', action.field], action.payload)
        }
        case actions.SET_TRAINING_LOCATION_FIELD: {
            const address = state.getIn(['training', 'address'])

            return address
                ? state.setIn(['training', 'address', action.field], action.payload)
                : state.setIn(['training', 'address'], fromJS({ [action.field]: action.payload }));
        }


        case actions.NEW_TRAINING: {
            return getInitialState().withMutations(mut => {
                mut.set('startDate', action.payload.startDate);
                mut.set('endDate', action.payload.endDate);
            })
        }

        case actions.ADD_TRAINING_PERSONNEL: {
            let newState = state;
            action.payload.forEach(payload => {
                newState = newState.updateIn(['training', 'personnel'], pl => {
                    const index = pl.findIndex(x => x.get('personId') === payload.personId);

                    if (index !== -1)
                        return pl.update(index, p => p.withMutations(mut => {
                            mut.set('personnelType', action.personnelType);
                            mut.set('isActive', true);
                            return mut;
                        }));
                    else
                        return pl.push(fromJS(
                            {
                                isActive: true,
                                trainingId: action.trainingId,
                                personId: payload.personId,
                                personnelType: action.personnelType,
                                person: payload
                            }));
                });
            });
            return newState;
        }

        case actions.ADD_TRAINING_DOCUMENT + actions.FULFILLED:
        case actions.DELETE_TRAINING_DOCUMENT + actions.FULFILLED:
        case actions.GET_TRAINING_DOCUMENTS + actions.FULFILLED:
            {
                return state.set('documents', fromJS(action.payload));
            }

        case actions.GET_TRAINING_JOURNAL + actions.FULFILLED:
        case actions.ADD_UPDATE_TRAINING_JOUNALENTRY + actions.FULFILLED:
        case actions.DELETE_TRAINING_JOUNALENTRIES + actions.FULFILLED:
            return state.set('journal', fromJS(action.payload));

        case actions.GET_TRAINING_CONTACTS + actions.FULFILLED:
        case actions.ADD_TRAINING_CONTACT + actions.FULFILLED:
        case actions.DELETE_TRAINING_CONTACT + actions.FULFILLED:
            return state.set('contacts', fromJS(action.payload));

        case actions.GET_TRAINING_FACULTY + actions.FULFILLED:
        case actions.ADD_TRAINING_FACULTY + actions.FULFILLED:
        case actions.DELETE_TRAINING_FACULTY + actions.FULFILLED:
            return state.set('faculty', fromJS(action.payload));

        case actions.GET_TRAINING_CURRICULUM + actions.FULFILLED:
        case actions.ADD_TRAINING_CURRICULUM + actions.FULFILLED:
        case actions.DELETE_TRAINING_CURRICULUM + actions.FULFILLED:
            return state.set('curriculum', fromJS(action.payload));

        case actions.GET_TRAINING_PROGRAMS + actions.FULFILLED:
        case actions.ADD_TRAINING_PROGRAMS + actions.FULFILLED:
        case actions.DELETE_TRAINING_PROGRAMS + actions.FULFILLED:
        case actions.ADD_PROGRAM_FROM_TRAINING + actions.FULFILLED:
            return state.set('programs', fromJS(action.payload));

        case actions.ADD_COURSE_FACULTY:
            {
                const { course, person } = action.payload;
                return state.update('curriculum', curriculum => {
                    const index = curriculum.findIndex(x => x.get('courseId') === course.courseId);

                    return curriculum.update(index, course => {
                        const faculty = course.get('faculty');
                        if (faculty) {
                            if (!faculty.find(x => x.get('personId') === person.personId))
                                return course.update('faculty', faculty => faculty.push(fromJS(person)));
                            else
                                return course;
                        }

                        else
                            return course.set('faculty', fromJS([person]));
                    });
                });
            }

        case actions.REMOVE_COURSE_FACULTY:
            {
                const { course, person } = action.payload;
                return state.update('curriculum', curriculum => {
                    const index = curriculum.findIndex(x => x.get('courseId') === course.courseId);

                    return curriculum.update(index, course =>
                        course.update('faculty', faculty => faculty.filter(x => x.get('personId') !== person.personId))
                    );
                });
            }
        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        training: {
            curriculum: [],
            personnel: [],
            programs: [],
            startDate: moment(),
            endDate: moment(),
            isActive: true
        },
        startDate: moment(),
        endDate: moment(),
        curriculum: [],
        documents: [],
        journal: [],
        contacts: [],
        faculty: [],
        programs: []
    });
};
